export default __webpack_public_path__ + "static/media/normal_u27.52485f65.png";